export default __webpack_public_path__ + "static/media/orange-arrow.254006b8.svg";